import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import PosTerminals from './PosTerminals'

const ManageDejavoo = ({ match }) => {
  return (
    <Fragment>
      <Route exact path={`${match.url}`} component={PosTerminals} />
    </Fragment>
  )
}

export default ManageDejavoo



// WEBPACK FOOTER //
// ./src/containers/Settings/Dejavoo/index.js